import template from './error-widget.html';
import controller from './error-widget.controller';
import './error-widget.styl';

let errorNotificationComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default errorNotificationComponent;



// WEBPACK FOOTER //
// ./client/app/common/error-widget/error-widget.component.js